import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, inject, Ref, watch, onMounted } from 'vue';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { Heading, ProgressBar } from '@warrenbrasil/nebraska-web';
import { EVariableIncomeAcquisitionSteps } from '../../helpers';


export default /*#__PURE__*/_defineComponent({
  __name: 'Loading',
  setup(__props) {

const isCreatingPortfolio = inject('isCreatingPortfolio') as Ref<boolean>;
const currentStep = inject(
  'currentStep'
) as Ref<EVariableIncomeAcquisitionSteps>;
const progress = ref(0);
const isEntering = ref(false);
const previousText = ref('');
let initialAnimationInterval: NodeJS.Timeout;

const texts = ['Criando carteira...', 'Solicitando investimento...', 'Pronto!'];

const currentText = computed(() => {
  if (progress.value >= 0.75) return texts[2];
  if (progress.value >= 0.4) return texts[1];
  if (progress.value >= 0.1) return texts[0];

  return '';
});

watch(currentText, (_newText, oldText) => {
  previousText.value = oldText;
  isEntering.value = true;
  setTimeout(() => {
    isEntering.value = false;
  }, 400);
});

const animateProgress = (targetValue: number, duration: number) => {
  const startValue = progress.value;
  const steps = 60;
  const stepDuration = duration / steps;
  let currentStep = 0;

  const interval = setInterval(() => {
    currentStep++;
    const currentProgress = currentStep / steps;

    if (currentStep >= steps) {
      progress.value = targetValue;
      clearInterval(interval);
      return;
    }

    progress.value = startValue + (targetValue - startValue) * currentProgress;
  }, stepDuration);

  return interval;
};

onMounted(() => {
  initialAnimationInterval = animateProgress(0.6, 2500);
});

watch(isCreatingPortfolio, newValue => {
  if (!newValue) {
    clearTimeout(initialAnimationInterval);

    animateProgress(1, 2000);

    setTimeout(() => {
      currentStep.value = EVariableIncomeAcquisitionSteps.CONCLUSION;
    }, 2500);
  }
});

return { __sfc: true,isCreatingPortfolio, currentStep, progress, isEntering, previousText, initialAnimationInterval, texts, currentText, animateProgress, NebraskaColors, Heading, ProgressBar }
}

})